import React from 'react';
var SemanticsContext = /*#__PURE__*/React.createContext({});
export default SemanticsContext;